export const BUYING_SESSION_PLACEHOLDER_IMAGE_WIDTH = 79
export const BUYING_SESSION_PLACEHOLDER_IMAGE_HEIGHT = 64

export * from './PlaceHolder'
